import styled from '@emotion/styled';

export const DashboardFinanzaComponent = styled.div`
  width: 85%;
  height: 86vh;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fafdff;
  position: fixed;
  right: 0px;
  overflow: auto;

  .finanzasContent {
    width: 100%;
    max-width: 900px;
  }

  .h2Title {
    color: #009700;
    font-size: 40px;
    margin-bottom: 20px;
  }

  .reportSection {
    background: #fff;
    border: 1px solid #e2e8ee;
    border-radius: 12px;
    padding: 24px;

    h3 {
      margin: 0 0 8px;
      color: #242323;
      font-size: 22px;
    }

    p {
      margin: 0 0 20px;
      color: #5a5a5a;
    }
  }

  .filtersRow {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 16px;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
      font-weight: 600;
      color: #242323;
    }
  }

  .inputs {
    border-radius: 10px;
    border: 1px solid #242323;
    padding: 8px 12px;
    min-width: 220px;
    text-transform: capitalize;
    background: #fff;
  }

  .downloadButton {
    border: 1px solid #242323 !important;
    border-radius: 10px !important;
    background: #242323 !important;
    color: white !important;
    padding: 10px 20px !important;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  }

  .downloadButton:disabled {
    opacity: 0.6;
  }
`;
